// Port of api/fuel/app/classes/filter/search/games/filters/query/game/expansions.php
import F from 'offline/filter/constants'
export default {
	name: 'game.expansions',
	priority: 10,
	require: function(config, filter) {
		return filter.expansions !== undefined && filter.expansions !== 1
	},
	run: function(config, filter, data, query) {
		if (config.cacheType === F.CACHE_COLLECTION) {
			query.where('c.collection_expansion', '=', filter.expansions ? 1 : 0)
		} else {
			query.where('g.game_type', '=', filter.expansions === 0 ? 1 : 2)
		}
	}
}
